module.exports = __webpack_public_path__ + "img/N7.104adee5.png";